import React from 'react';
import CoverPage from './CoverPage';
import TitleGraphTextPage from './TitleGraphTextPage';
import TitleTextGraphPage from './TitleTextGraphPage';
import TitleGraphPage from './TitleGraphPage';
import TitleGraphGraphPage from './TitleGraphGraphPage';

const PageContentRenderer = ({ page, pageType, elements, handleDynamicChange, validation, edit = true, date_ini, date_end, period, report, setLocalReportFinal }) => {
    const renderSelectedPage = () => {
        switch (pageType) {
            case 'TitleImagePage':
                return (
                    <TitleImagePage
                        elements={elements}
                        page={page}
                        handleDynamicChange={handleDynamicChange}
                        edit={edit}
                    />
                );
            case 'TitleGraphTextPage':
                return (
                    <TitleGraphTextPage
                        elements={elements}
                        page={page}
                        handleDynamicChange={handleDynamicChange}
                        validation={validation}
                        edit={edit}
                        date_ini={date_ini}
                        date_end={date_end}
                    />
                );
            case 'TitleTextGraphPage':
                return (
                    <TitleTextGraphPage
                        elements={elements}
                        page={page}
                        handleDynamicChange={handleDynamicChange}
                        validation={validation}
                        edit={edit}
                        date_ini={date_ini}
                        date_end={date_end}
                    />
                );
            case 'TitleGraphPage':
                return (
                    <TitleGraphPage
                        // elements={elements}
                        page={page}
                        handleDynamicChange={handleDynamicChange}
                        validation={validation}
                        edit={edit}
                        // date_ini={date_ini}
                        // date_end={date_end}
                        report={report}
                        setLocalReportFinal={setLocalReportFinal}
                    />
                );
            case 'TitleGraphGraphPage':
                return (
                    <TitleGraphGraphPage
                        elements={elements}
                        page={page}
                        handleDynamicChange={handleDynamicChange}
                        validation={validation}
                        edit={edit}
                        date_ini={date_ini}
                        date_end={date_end}
                    />
                );
            case 'CoverPage':
                return (
                    <CoverPage
                        elements={elements}
                        page={page}
                        handleDynamicChange={handleDynamicChange}
                        edit={edit}
                        period={period}
                    />
                );
            case 'SectionImagePage':
                return (
                    <SectionImagePage
                        elements={elements}
                        page={page}
                        handleDynamicChange={handleDynamicChange}
                        edit={edit}
                        period={period}
                    />
                );
            default:
                return null;
        }
    };

    return (
        <>
            {renderSelectedPage()}
        </>
    );
};

export default PageContentRenderer;
